import { OutcomeType } from '../../Models/Survey/OutcomeType';
import { AnswerSurveyResult } from '../../../Common/Models/Api/Models/AnswerSurveyResult';
import { SurveyQuestionInfo } from '../../../Common/Models/Api/Info/SurveyQuestionInfo';
import { Injectable } from '@angular/core';
import { ApiResponse, VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { SpaContext } from '../../../Classes/spacontext';
import { Observable } from 'rxjs';

@Injectable()
export class SurveyService {
	readonly baseUri: string = '/Api/Client/v2/units';

	constructor(
		private _http: VisibaApiHttp,
		public _spaContext: SpaContext,
	) {}

	getSurvey(alias: string): Observable<ApiResponse<Array<SurveyQuestionInfo>>> {
		return this._http.getTyped<Array<SurveyQuestionInfo>>(
			`${this.baseUri}/${this._spaContext.unitConfig.Unit.UnitId}/Surveys/${alias}`,
		);
	}

	postSurveyAnswer(alias: string, answers: any, bookingCallTicket: string): Observable<ApiResponse<AnswerSurveyResult>> {
		const postData = {
			Answers: answers,
			AppointmentTicket: bookingCallTicket,
		};

		return this._http.postTyped<AnswerSurveyResult>(
			`${this.baseUri}/${this._spaContext.unitConfig.Unit.UnitId}/Surveys/${alias}`,
			postData,
		);
	}

	// Resource
	getResourceSurvey(alias: string, langCode: string): Observable<ApiResponse<Array<SurveyQuestionInfo>>> {
		return this._http.getTyped<Array<SurveyQuestionInfo>>(
			`/Api/Office/${this._spaContext.unitConfig.LicenceHolder.Id}/Surveys/${alias}/questions/${langCode}`,
		);
	}

	getOutcomeDefinitions(): Observable<ApiResponse<Array<OutcomeType>>> {
		return this._http.getTyped<Array<OutcomeType>>(
			`/Api/Office/${this._spaContext.unitConfig.LicenceHolder.Id}/Outcomes/definitions`,
		);
	}

	postResourceSurveyAnswer(alias: string, answers: any, bookingCallTicket: string): Observable<ApiResponse<AnswerSurveyResult>> {
		const postData = {
			Answers: answers,
			BookingCallTicket: bookingCallTicket,
		};

		return this._http.postTyped<AnswerSurveyResult>(
			`/Api/Office/${this._spaContext.unitConfig.LicenceHolder.Id}/Surveys/${alias}`,
			postData,
		);
	}

	RegisterCallOutcome(
		icdCodes: string[],
		outcomes: Array<OutcomeType>,
		wasFitForDigitalVisit: boolean,
		customOutcome: string,
		bookingId: number,
	): Observable<ApiResponse<void>> {
		const postData = {
			IcdCodes: icdCodes,
			Outcomes: outcomes,
			WasFitForDigitalVisit: wasFitForDigitalVisit,
			CustomOutcome: customOutcome,
		};

		return this._http.postTyped<void>(`/Api/Office/${this._spaContext.unitConfig.LicenceHolder.Id}/Outcomes/${bookingId}`, postData);
	}
}
